import { useEffect, useState } from 'react';

export interface BannerPromo {
  id: number;
  texto?: string | null;
  imagen_url?: string | null;
}

interface Props {
  banners: BannerPromo[];
  intervaloMs?: number;
}

export default function Carrusel({ banners, intervaloMs = 4500 }: Props) {
  const [activo, setActivo] = useState(0);
  const visibles = banners.filter((b) => b.imagen_url);

  useEffect(() => {
    if (visibles.length <= 1) return;
    const id = setInterval(() => {
      setActivo((prev) => (prev + 1) % visibles.length);
    }, intervaloMs);
    return () => clearInterval(id);
  }, [visibles.length, intervaloMs]);

  if (visibles.length === 0) return null;

  return (
    <div className="relative w-full h-[280px] sm:h-[380px] md:h-[460px] rounded-3xl overflow-hidden shadow-soft">
      {visibles.map((b, i) => (
        <div
          key={b.id}
          className="absolute inset-0 transition-opacity duration-700 ease-in-out"
          style={{ opacity: i === activo ? 1 : 0 }}
        >
          <img src={b.imagen_url!} alt={b.texto ?? 'Soda Celes'} className="w-full h-full object-cover" />
          {b.texto && (
            <div
              className="absolute bottom-0 left-0 right-0 p-6 pt-16"
              style={{ background: 'linear-gradient(to top, rgba(21,0,18,0.85), transparent)' }}
            >
              <p className="text-white font-display font-bold text-lg sm:text-xl">{b.texto}</p>
            </div>
          )}
        </div>
      ))}

      {visibles.length > 1 && (
        <div className="absolute bottom-4 right-4 flex gap-1.5 z-10">
          {visibles.map((b, i) => (
            <button
              key={b.id}
              onClick={() => setActivo(i)}
              aria-label={`Ver foto ${i + 1}`}
              className="w-2 h-2 rounded-full transition-all"
              style={{
                background: i === activo ? '#E4A53A' : 'rgba(255,255,255,0.5)',
                width: i === activo ? '20px' : '8px',
              }}
            />
          ))}
        </div>
      )}
    </div>
  );
}
